import React from "react";

import { Button, Img, Input, List, PagerIndicator, Text } from "components";
import CategoryFeatureProducts from "components/CategoryFeatureProducts";
import ContextMenu from "components/ContextMenu";
import Footer1 from "components/Footer1";
import Header from "components/Header";
import InfoRibbon from "components/InfoRibbon";

import { CloseSVG } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import QuicklookdialogPage from "../../components/Quicklookdialog";

const CategorypagePage = () => {
  const navigate = useNavigate();
  const [searchinputvalue, setSearchinputvalue] = React.useState("");
  const [showDialog, setShowDialog] = React.useState(false);

  return (
    <>
      <div className="bg-gray-100 flex flex-col font-inter items-center justify-start mx-auto w-full">
        <InfoRibbon className="bg-deep_purple-900 flex flex-row md:gap-10 items-center justify-between p-3 w-full" />
        <Header className="bg-white-A700 flex flex-col items-center justify-center md:px-5 w-full sticky top-0" />
        <ContextMenu className="bg-white-A700 flex sm:flex-col flex-row gap-5 items-center justify-center p-[38px] sm:px-5 w-full" />
        <Text
          className="leading-[24.00px] mt-[45px] text-2xl md:text-[22px] text-center text-gray-900_02 sm:text-xl tracking-[0.18px]"
          size="txtInterRegular24"
        >
          <>
            Haier TV is a high performing unit <br />
            with its exceptional picture clarity and innovative features.
          </>
        </Text>
        <List
          className="flex flex-col gap-[41px] items-center max-w-[1232px] mt-[41px] mx-auto md:px-5 w-full"
          orientation="vertical"
        >
          <CategoryFeatureProducts setShowDialog={setShowDialog}
                                   className="flex flex-1 md:flex-col flex-row gap-5 items-center justify-between w-full" />
          <CategoryFeatureProducts setShowDialog={setShowDialog}
                                   className="flex flex-1 md:flex-col flex-row gap-5 items-center justify-between w-full" />
          <CategoryFeatureProducts setShowDialog={setShowDialog}
                                   className="flex flex-1 md:flex-col flex-row gap-5 items-center justify-between w-full" />
        </List>
        <Button
          className="!text-white-A700 cursor-pointer min-w-[1232px] md:min-w-full mt-[58px] text-2xl md:text-[22px] text-center sm:text-xl tracking-[0.18px]"
          color="deep_purple_900_01"
          size="sm"
          shape="round"
          variant="fill"
          onClick={() => navigate("/productspage")}
        >
          SHOP NOW ALL TVs
        </Button>
        <Footer1 className="bg-blue_gray-900 flex items-center justify-center mt-16 md:px-5 w-full" />
      </div>
      <QuicklookdialogPage show={showDialog} onClose={() => setShowDialog(false)} />
    </>
  );
};

export default CategorypagePage;
